import { JoyField, isString, isDate } from 'joy-core';
export default class ACDealData {
    /**
     * Create a new ACDealData object.
     * @param data A map of JoyField/value pairs that define the object properties.
     */
    constructor(data) {
        if (!isString(data[JoyField.id])) {
            return null;
        }
        this.id = data[JoyField.id];
        if (!isString(data[JoyField.user])) {
            return null;
        }
        this.owner = data[JoyField.user];
        if (!isString(data[JoyField.contact])) {
            return null;
        }
        this.contact = data[JoyField.contact];
        if (!isString(data[JoyField.name])) {
            return null;
        }
        this.title = data[JoyField.name];
        if (!isString(data[JoyField.description])) {
            return null;
        }
        this.description = data[JoyField.description];
        if (!isDate(data[JoyField.createdAt])) {
            return null;
        }
        this.createdAt = data[JoyField.createdAt];
    }
}
//# sourceMappingURL=ACDealData.js.map